/**
 * Client Query Types
 *
 * Core types for the query client.
 */

// ============================================================================
// Query Result Types
// ============================================================================

/**
 * Count-only result.
 */
export interface CountResult {
  count: number;
}

// ============================================================================
// Configuration
// ============================================================================

export interface ClientConfig {
  baseUrl: string;
  tokenTemplate?: string;
}

let _config: ClientConfig = {
  baseUrl: "/api/v5",
  tokenTemplate: "birdwatch-template",
};

export function configureClient(config: Partial<ClientConfig>): void {
  _config = { ..._config, ...config };
}

export function getClientConfig(): ClientConfig {
  return _config;
}
